<div class="wrapper p-2 p-md-4">
  <div class="list-sessions-content p-2 p-md-4">
    <div class="justify-content-start d-flex align-items-center">
      <div class=" d-flex align-items-center go-back" style="cursor: pointer" (click)="goBack()">
        <fa-icon class="icon-go-back" [icon]="faArrowLeft"></fa-icon>
        <p class="mb-0">Volver</p>
      </div>
    </div>

    <div class="sessions-wrapper w-100 p-2 p-md-3" style="min-height: 90vh; margin: auto; margin-top: 20px">
      <p class="sessions-title">
        Histórico de sesiones
      </p>

      <!-- Filtros -->
      <div [formGroup]="filterForm" class="filters-bar">
        <!-- Buscador por sesión -->
        <div class="searchbar">
          <fa-icon [icon]="faMagnifyingGlass"></fa-icon>
          <input type="text" formControlName="sessionSearch" placeholder="Buscar sesión...">
        </div>

        <!-- Selector de fecha (rango) -->
        <div class="date-pill date-pill-range" (click)="rangePicker.open()" style="position:relative">
          <i class="fal fa-calendar"></i>
          <span class="date-pill-label" [class.has-value]="filterForm.get('dateFrom')!.value">{{ dateRangeLabel }}</span>
          <mat-date-range-input [rangePicker]="rangePicker" [max]="today"
            style="position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none">
            <input matStartDate formControlName="dateFrom" (dateChange)="onDateChange()">
            <input matEndDate formControlName="dateTo" (dateChange)="onDateChange()">
          </mat-date-range-input>
          <mat-date-range-picker #rangePicker (opened)="onPickerOpen()" (closed)="onDateChange()"></mat-date-range-picker>
        </div>

        <!-- Limpiar filtros -->
        <div *ngIf="hasActiveFilters" class="clear-filter-btn" (click)="clearFilters()">
          <fa-icon [icon]="faXmark"></fa-icon>
          <p>Limpiar</p>
        </div>
      </div>

      <!-- Spinner carga inicial / filtros -->
      <div class="table-loading" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="48">
        </mat-progress-spinner>
      </div>

      <ng-container *ngIf="!loading">
        <!-- Cabecera tabla (solo desktop) -->
        <div class="row table-header align-items-center d-none d-md-flex">
          <div class="col-1"></div>
          <div class="col-1 text-center">Sesión</div>
          <div class="col-2 text-start">Nombre de caja</div>
          <div class="col-2 text-center">Estado</div>
          <div class="col-2 text-center">Balance inicial</div>
          <div class="col-2 text-center">Hora apertura</div>
          <div class="col-2 text-center">Hora cierre</div>
        </div>

        <!-- Filas tabla (solo desktop) -->
        <div class="row table-rows align-items-center d-none d-md-flex" *ngFor="let session of sessionsData"
          (click)="viewSession(session.id)">
          <div class="col-1 text-start">
            <fa-icon class="table-icon" [icon]="faMagnifyinGlassPlus"></fa-icon>
          </div>
          <div class="col-1 text-center">{{ session.id }}</div>
          <div class="col-2 text-start p-0">
            <span *ngIf="checkNameCashRegister(session.cash_register)">
              {{ session.cash_register.name }}
            </span>
          </div>
          <div class="col-2 justify-content-center d-flex align-items-center gap-2">
            <svg [ngStyle]="{ color: session.closed ? '#e9574d' : '#60D564' }" role="img" aria-hidden="true"
              focusable="false" data-prefix="fas" data-icon="circle" class="svg-inline--fa fa-circle"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"></path>
            </svg>
            <span>{{ session.closed ? 'Cerrada' : 'Abierta' }}</span>
          </div>
          <div class="col-2 text-center">{{ formatNumber(session.initial_balance) }}</div>
          <div class="col-2 text-center">{{ session.created_at | date : "dd/MM/yyyy - HH:mm" }}</div>
          <div class="col-2 text-center">
            <span>{{ session.created_at !== session.updated_at ? (session.updated_at | date : "dd/MM/yyyy - HH:mm") : '-' }}</span>
          </div>
        </div>

        <!-- Sin resultados -->
        <div class="empty-state" *ngIf="sessionsData.length === 0">
          <p>No se han encontrado sesiones con los filtros aplicados</p>
        </div>

        <!-- Tarjetas móvil (solo mobile) -->
        <div class="session-card d-flex d-md-none" *ngFor="let session of sessionsData"
          (click)="viewSession(session.id)">
          <div class="session-card-header">
            <div class="session-card-id">#{{ session.id }}</div>
            <div class="session-card-status" [ngStyle]="{ color: session.closed ? '#e9574d' : '#60D564' }">
              <svg role="img" aria-hidden="true" focusable="false" class="svg-inline--fa fa-circle"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"></path>
              </svg>
              <span>{{ session.closed ? 'Cerrada' : 'Abierta' }}</span>
            </div>
          </div>
          <div class="session-card-name" *ngIf="checkNameCashRegister(session.cash_register)">
            {{ session.cash_register.name }}
          </div>
          <div class="session-card-details">
            <div class="session-card-detail">
              <span class="detail-label">Balance</span>
              <span class="detail-value">{{ formatNumber(session.initial_balance) }}</span>
            </div>
            <div class="session-card-detail">
              <span class="detail-label">Apertura</span>
              <span class="detail-value">{{ session.created_at | date : "dd/MM/yyyy HH:mm" }}</span>
            </div>
            <div class="session-card-detail">
              <span class="detail-label">Cierre</span>
              <span class="detail-value">{{ session.created_at !== session.updated_at ? (session.updated_at | date : "dd/MM/yyyy HH:mm") : '-' }}</span>
            </div>
          </div>
          <fa-icon class="session-card-arrow" [icon]="faMagnifyinGlassPlus"></fa-icon>
        </div>
      </ng-container>
    </div>

    <!-- Spinner scroll infinito -->
    <div class="loading-spinner" *ngIf="loadingMore">
      <mat-progress-spinner color="accent" mode="indeterminate" diameter="40">
      </mat-progress-spinner>
    </div>
  </div>
</div>

<!-- Botón flotante scroll al inicio -->
<button class="scroll-to-top-btn" *ngIf="showScrollTop" (click)="scrollToTop()" aria-label="Volver al inicio">
  <fa-icon [icon]="faArrowUp"></fa-icon>
</button>